import React from 'react';
import { Outlet } from 'react-router-dom';
import { AppBarContainer } from '../components/shared/appBar/appBar.container';
import { Alert, Container } from '@mui/material';
import { useAuthenticatedUser } from '../hooks/useAuthenticatedUser';

export const MainLayout: React.FC = () => {
  const { isImpersonating, user, impersonatedByAdmin } = useAuthenticatedUser();

  return (
    <>
      {/* Common AppBar */}
      <AppBarContainer />

      {/* Content */}
      <Container sx={{ maxWidth: {md: "100%",  lg: 1200} }}>
        {isImpersonating && (
          <Alert severity="warning" sx={{ mt: '88px', mb: 2 }}>
            You are logged in as {user?.firstName} {user?.lastName} ({user?.email}) as an admin impersonation.
            {impersonatedByAdmin?.email ? ` Admin account: ${impersonatedByAdmin.email}.` : ''}
          </Alert>
        )}
        <main style={{ marginTop: isImpersonating ? '0px' : '100px' }}> {/* Adjust for AppBar height */}
          <Outlet />
        </main>
      </Container>

    </>
  );
};
